type Numero = { id: string };
export type PesoNumeroInput = { numeroOperacionalId: string; pesoBasisPoints: number };

export function exibirPercentual(pesoBasisPoints: number) {
  return (pesoBasisPoints / 100).toLocaleString("pt-BR", { maximumFractionDigits: 2 });
}

export function percentualParaBasisPoints(valor: string): number | null {
  const texto = valor.trim();
  if (!/^\d{1,3}(?:[,.]\d{1,2})?$/.test(texto)) return null;
  const [inteiro, decimais = ""] = texto.replace(",", ".").split(".");
  const peso = Number(inteiro) * 100 + Number(decimais.padEnd(2, "0"));
  return peso >= 1 && peso <= 10000 ? peso : null;
}

export function validarPercentuaisParaSalvar(numeros: readonly Numero[], rascunhos: Readonly<Record<string, string>>):
  { pesos: PesoNumeroInput[] } | { erro: string } {
  if (numeros.length < 2 || numeros.length > 3 || new Set(numeros.map((numero) => numero.id)).size !== numeros.length) {
    return { erro: "Salve os números antes de configurar os percentuais." };
  }
  const pesos: PesoNumeroInput[] = [];
  for (const numero of numeros) {
    if (!numero.id) return { erro: "Salve os números antes de configurar os percentuais." };
    const pesoBasisPoints = percentualParaBasisPoints(rascunhos[numero.id] ?? "");
    if (pesoBasisPoints === null) return { erro: "Informe um percentual válido para cada número, com até duas casas decimais." };
    pesos.push({ numeroOperacionalId: numero.id, pesoBasisPoints });
  }
  if (pesos.reduce((total, peso) => total + peso.pesoBasisPoints, 0) !== 10000) {
    return { erro: "A soma dos percentuais deve ser 100%." };
  }
  return { pesos };
}
